import React, { Component, Fragment } from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import NewSignUp from '.';
import Loading from '../shared/Loading';
import { Helmet } from 'react-helmet';

const GET_ALL_CITIES = gql`
  query accessibleCities {
    accessibleCities {
      id
      name
    }
  }
`;

const GetCities = ({ country, city, refCode }) => {
  return (
    <Query query={GET_ALL_CITIES}>
      {({ loading, error, data, refetch }) => {
        console.log(data);

        if (loading)
          return (
            <div className="load-div">
              <Loading size="3x" />
            </div>
          );
        if (data.accessibleCities) {
          return (
            <Fragment>
              <Helmet>
                <title>Autzu | Sign up</title>
                <meta
                  name="description"
                  content="Rent a car to drive and earn on ridesharing platforms with no upfront payments or term-commitments. From only $7/hour, we provide a pre-qualified car and include maintenance, insurance, parking and 24/7 roadside assistance."
                />
              </Helmet>
              <NewSignUp
                country={country}
                city={city}
                refCode={refCode}
                accessibleCities={data.accessibleCities}
              />
            </Fragment>
          );
        }
      }}
    </Query>
  );
};

export default GetCities;



// WEBPACK FOOTER //
// ./src/components/NewSignUp/GetCities.js